import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService {
    constructor() {}

    // save data to localStorage
    setItem(key: string, value: any): void {
        localStorage.setItem(key, JSON.stringify(value));
    }

    // get data from localStorage
    getItem(key: string): any {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    }

    // remove data from localStorage
    removeItem(key: string): void {
        localStorage.removeItem(key);
    }

    // clear all data from localStorage
    clear(): void {
        localStorage.clear();
    }
}
